/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ExternalMCPToolDefinition,
  ExternalMCPToolDefinition$inboundSchema,
} from "./externalmcptooldefinition.js";
import {
  FunctionToolDefinition,
  FunctionToolDefinition$inboundSchema,
} from "./functiontooldefinition.js";
import {
  HTTPToolDefinition,
  HTTPToolDefinition$inboundSchema,
} from "./httptooldefinition.js";
import {
  PlatformToolDefinition,
  PlatformToolDefinition$inboundSchema,
} from "./platformtooldefinition.js";
import {
  PromptTemplate,
  PromptTemplate$inboundSchema,
} from "./prompttemplate.js";

/**
 * A polymorphic tool - can be an HTTP tool, function tool, prompt template, or external MCP proxy
 */
export type Tool = {
  /**
   * A proxy tool that references an external MCP server
   */
  externalMcpToolDefinition?: ExternalMCPToolDefinition | undefined;
  /**
   * A function tool
   */
  functionToolDefinition?: FunctionToolDefinition | undefined;
  /**
   * An HTTP tool
   */
  httpToolDefinition?: HTTPToolDefinition | undefined;
  /**
   * A platform-owned tool served directly by the platform
   */
  platformToolDefinition?: PlatformToolDefinition | undefined;
  /**
   * A prompt template
   */
  promptTemplate?: PromptTemplate | undefined;
};

/** @internal */
export const Tool$inboundSchema: z.ZodMiniType<Tool, unknown> = z.pipe(
  z.object({
    external_mcp_tool_definition: z.optional(
      ExternalMCPToolDefinition$inboundSchema,
    ),
    function_tool_definition: z.optional(FunctionToolDefinition$inboundSchema),
    http_tool_definition: z.optional(HTTPToolDefinition$inboundSchema),
    platform_tool_definition: z.optional(PlatformToolDefinition$inboundSchema),
    prompt_template: z.optional(PromptTemplate$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "external_mcp_tool_definition": "externalMcpToolDefinition",
      "function_tool_definition": "functionToolDefinition",
      "http_tool_definition": "httpToolDefinition",
      "platform_tool_definition": "platformToolDefinition",
      "prompt_template": "promptTemplate",
    });
  }),
);

export function toolFromJSON(
  jsonString: string,
): SafeParseResult<Tool, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Tool$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Tool' from JSON`,
  );
}
